import { render, staticRenderFns } from "./StudipDateTime.vue?vue&type=template&id=fd3f1c0c&"
import script from "./StudipDateTime.vue?vue&type=script&lang=js&"
export * from "./StudipDateTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/moritz/html/v4.6-hsfl/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fd3f1c0c')) {
      api.createRecord('fd3f1c0c', component.options)
    } else {
      api.reload('fd3f1c0c', component.options)
    }
    module.hot.accept("./StudipDateTime.vue?vue&type=template&id=fd3f1c0c&", function () {
      api.rerender('fd3f1c0c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/vue/components/StudipDateTime.vue"
export default component.exports